import { CategorieDossier } from "adel-shared/dist/enums/CategorieDossier";

enum DossierView {
  List = "List",
  Edit = "Edit",
}

export { CategorieDossier, DossierView };
